// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.home-container {
  background: #e6f7ff;
  padding: 20px;
}

.question-list {
  display: grid;
  gap: 20px;
}

.question-card {
  background: rgba(255, 255, 255, 0.9);
  border: 1px solid #b3e0ff;
  border-radius: 8px;
  padding: 15px;
  box-shadow: 0 2px 4px rgba(179, 224, 255, 0.1);
}

.card-footer {
  display: flex;
  gap: 10px;
  align-items: center;
  margin-top: 12px;
}

.start-btn {
  width: 128px;                
  height: 25px;
  padding: 6px 12px;
  background: #3077b0;
  color: white;
  border-radius: 20px;
  text-decoration: none;
  border: none;
  cursor: pointer;
  transition: opacity 0.3s;
}

.like-btn {
  background: #3077b0;
  border-radius: 50%;         /* 圆形按钮，视觉小巧 */
  width: 64px;                
  height: 32px;
  min-width: 10px;
  padding: 0;                 /* 取消多余内边距 */
  display: flex;              /* 居中内容 */
  align-items: center;
  justify-content: center;
  color: white;               /* 保证icon或文本是白色 */
  border: none;
  cursor: pointer;
  transition: opacity 0.3s;
  font-size: 18px;            /* 图标或字体大小合适 */
}

.like-btn:hover {
  opacity: 0.8;
}

.instructions-container {
  margin-bottom: 30px;
  background: rgba(255, 255, 255, 0.95);
  border: 1px solid #4a90e2;
}

.toggle-instructions {
  background: #f0f9ff;
  color: #2d6da4;
}

.question-link {
  text-decoration: none !important; 
  color: inherit;                   
}

.question-link:hover {
  text-decoration: none !important; 
}

.footer {
  text-align: center;
  padding: 20px;
  font-size: 14px;
  color: #666;
}
.footer a {
  color: #666;
  text-decoration: none;
}
.footer a:hover {
  color: #1890ff;
}
`, "",{"version":3,"sources":["webpack://./src/HomePage.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,qBAAqB;EACrB,YAAY;EACZ,eAAe;EACf,wBAAwB;AAC1B;;AAEA;EACE,mBAAmB;EACnB,kBAAkB,UAAU,cAAc;EAC1C,WAAW;EACX,YAAY;EACZ,eAAe;EACf,UAAU,kBAAkB,YAAY;EACxC,aAAa,eAAe,SAAS;EACrC,mBAAmB;EACnB,uBAAuB;EACvB,YAAY,gBAAgB,iBAAiB;EAC7C,YAAY;EACZ,eAAe;EACf,wBAAwB;EACxB,eAAe,aAAa,cAAc;AAC5C;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,qCAAqC;EACrC,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,WAAW;AACb;AACA;EACE,WAAW;EACX,qBAAqB;AACvB;AACA;EACE,cAAc;AAChB","sourcesContent":[".home-container {\n  background: #e6f7ff;\n  padding: 20px;\n}\n\n.question-list {\n  display: grid;\n  gap: 20px;\n}\n\n.question-card {\n  background: rgba(255, 255, 255, 0.9);\n  border: 1px solid #b3e0ff;\n  border-radius: 8px;\n  padding: 15px;\n  box-shadow: 0 2px 4px rgba(179, 224, 255, 0.1);\n}\n\n.card-footer {\n  display: flex;\n  gap: 10px;\n  align-items: center;\n  margin-top: 12px;\n}\n\n.start-btn {\n  width: 128px;                \n  height: 25px;\n  padding: 6px 12px;\n  background: #3077b0;\n  color: white;\n  border-radius: 20px;\n  text-decoration: none;\n  border: none;\n  cursor: pointer;\n  transition: opacity 0.3s;\n}\n\n.like-btn {\n  background: #3077b0;\n  border-radius: 50%;         /* 圆形按钮，视觉小巧 */\n  width: 64px;                \n  height: 32px;\n  min-width: 10px;\n  padding: 0;                 /* 取消多余内边距 */\n  display: flex;              /* 居中内容 */\n  align-items: center;\n  justify-content: center;\n  color: white;               /* 保证icon或文本是白色 */\n  border: none;\n  cursor: pointer;\n  transition: opacity 0.3s;\n  font-size: 18px;            /* 图标或字体大小合适 */\n}\n\n.like-btn:hover {\n  opacity: 0.8;\n}\n\n.instructions-container {\n  margin-bottom: 30px;\n  background: rgba(255, 255, 255, 0.95);\n  border: 1px solid #4a90e2;\n}\n\n.toggle-instructions {\n  background: #f0f9ff;\n  color: #2d6da4;\n}\n\n.question-link {\n  text-decoration: none !important; \n  color: inherit;                   \n}\n\n.question-link:hover {\n  text-decoration: none !important; \n}\n\n.footer {\n  text-align: center;\n  padding: 20px;\n  font-size: 14px;\n  color: #666;\n}\n.footer a {\n  color: #666;\n  text-decoration: none;\n}\n.footer a:hover {\n  color: #1890ff;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
